"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _InputActions = _interopRequireDefault(require("../../InputActions"));
var _useForkRef = _interopRequireDefault(require("@mui/material/utils/useForkRef"));
var _styles = require("@mui/styles");
var _clsx = _interopRequireDefault(require("clsx"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["value", "type", "onBlur", "onFocus", "tabIndex", "disabled", "inputRef", "name", "autoFocus", "className", "open", "icon", "iconProps", "placeholder", "valueLikePlaceholder", "actions"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    placeholder: {
      color: theme.palette.text.disabled
    },
    input: {
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      paddingRight: function paddingRight(_ref) {
        var actionsCount = _ref.actionsCount;
        return actionsCount ? actionsCount * 22 + 8 : 50;
      }
    }
  };
});
var InputComponent = /*#__PURE__*/(0, _react.forwardRef)(function (_ref2, ref) {
  var valueProp = _ref2.value,
    omittedType = _ref2.type,
    onBlur = _ref2.onBlur,
    onFocus = _ref2.onFocus,
    tabIndexProp = _ref2.tabIndex,
    disabled = _ref2.disabled,
    inputRef = _ref2.inputRef,
    name = _ref2.name,
    autoFocus = _ref2.autoFocus,
    className = _ref2.className,
    open = _ref2.open,
    icon = _ref2.icon,
    iconProps = _ref2.iconProps,
    placeholder = _ref2.placeholder,
    valueLikePlaceholder = _ref2.valueLikePlaceholder,
    actions = _ref2.actions,
    props = _objectWithoutProperties(_ref2, _excluded);
  var classes = useStyles({
    actionsCount: actions === null || actions === void 0 ? void 0 : actions.length
  });
  var displayNodeRef = (0, _react.useRef)(null);
  var handleRef = (0, _useForkRef["default"])(ref, inputRef);
  var tabIndex;
  if (typeof tabIndexProp !== 'undefined') {
    tabIndex = tabIndexProp;
  } else {
    tabIndex = disabled ? null : 0;
  }
  var handleBlur = function handleBlur(e) {
    if (!open && onBlur) {
      onBlur(e);
    }
  };
  (0, _react.useEffect)(function () {
    if (autoFocus && displayNodeRef.current) {
      displayNodeRef.current.focus();
    }
  }, [autoFocus]);
  var value = valueProp;
  if (valueLikePlaceholder) {
    value = /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: classes.placeholder,
      children: value
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: (0, _clsx["default"])(className, classes.input),
      onBlur: handleBlur,
      onFocus: onFocus,
      tabIndex: tabIndex,
      ref: displayNodeRef,
      children: value
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("input", _objectSpread({
      value: valueProp,
      name: name,
      ref: handleRef,
      type: 'hidden',
      autoFocus: autoFocus
    }, props)), actions !== null && actions !== void 0 && actions.length ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_InputActions["default"], {
      children: actions
    }) : (/*#__PURE__*/_react["default"].cloneElement(icon, _objectSpread({
      disabled: disabled,
      color: disabled ? 'disabled' : 'action'
    }, iconProps)))]
  });
});
var _default = exports["default"] = InputComponent;